import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader, XCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // checking, success, error
  const [message, setMessage] = useState('Verifying your payment...');
  const sessionId = searchParams.get('session_id');
  
  useEffect(() => {
    // Payment success - redirect to dashboard
    setStatus('success');
    setMessage('Payment successful! Redirecting to your dashboard...');
    setTimeout(() => navigate('/dashboard'), 2000);
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-deep-dark flex items-center justify-center" data-testid="payment-success-page">
      <div className="max-w-md w-full mx-4">
        <div className="bg-dark-surface p-8 rounded-xl border border-premium-gold/30/50 text-center">
          {status === 'checking' && (
            <>
              <div className="w-20 h-20 bg-premium-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Loader className="w-10 h-10 text-premium-gold animate-spin" />
              </div>
              <h2 
                className="text-2xl font-bold mb-3 text-white"
                style={{ fontFamily: 'Fraunces, serif' }}
              >
                Processing Payment
              </h2>
              <p className="text-white/60">{message}</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-emerald-400" />
              </div>
              <h2 
                className="text-2xl font-bold mb-3 text-emerald-400"
                style={{ fontFamily: 'Fraunces, serif' }}
                data-testid="success-message"
              >
                Payment Successful!
              </h2>
              <p className="text-white/60">{message}</p>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="w-20 h-20 bg-premium-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-premium-gold" />
              </div>
              <h2 
                className="text-2xl font-bold mb-3 text-premium-gold"
                style={{ fontFamily: 'Fraunces, serif' }}
                data-testid="error-message"
              >
                Payment Issue
              </h2>
              <p className="text-white/60">{message}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
